<mat-card class="admin-post-card overflow-hidden">
  <!-- <mat-card-header>
    <img mat-card-avatar [src]="postData.creatorImg" onerror="this.src='./assets/images/user-avatar.svg'" alt="" />
    <mat-card-title>{{postData.creatorName}}</mat-card-title>
    <mat-card-subtitle><small>{{ postData.creationTime | date }}</small></mat-card-subtitle>
    <mat-menu #menu="matMenu">
      <button (click)="onDeactivate()" mat-menu-item  >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span>Delete</span>
      </button>
    </mat-menu>
  </mat-card-header> -->


  <!-- placeholder text start -->
  <div class="placeholder_heading_tr" *ngIf="!postData.assetInfo || postData.assetInfo?.length == 0 "  >
           <h3>{{postData.postTitle.slice(0,1).toUpperCase()}}</h3>
        </div>

  <!-- <div class="card-carousel" *ngIf="postData.postThumbImage && postData.postThumbImage !='null' ">
    <img [src]="postData.postThumbImage ? postData.postThumbImage : postData.postThumbImage" alt="" onerror="this.src='../../../../assets/images/photo.png'" style="
    height: 100% !important;
    width: 100% !important;
    object-fit: cover;
    object-position: center;">
  </div> -->

<div class="admin_headigtty" *ngIf="postData.assetInfo && postData.assetInfo?.length > 0 ">
  <owl-carousel-o [options]="elatestposts">
  <ng-container>
     <ng-template carouselSlide *ngFor="let item of postData.assetInfo">
      <div class="post_details_img" >
                <!-- <div class="play_btn_text">
           <svg  xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 30.051 30.051" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="m19.982 14.438-6.24-4.536a.752.752 0 0 0-1.195.607v9.069a.75.75 0 0 0 1.195.606l6.24-4.532a.747.747 0 0 0 0-1.214z" fill="#ffffff" opacity="1" data-original="#000000"></path><path d="M15.026.002C6.726.002 0 6.728 0 15.028c0 8.297 6.726 15.021 15.026 15.021 8.298 0 15.025-6.725 15.025-15.021.001-8.3-6.727-15.026-15.025-15.026zm0 27.54c-6.912 0-12.516-5.601-12.516-12.514 0-6.91 5.604-12.518 12.516-12.518 6.911 0 12.514 5.607 12.514 12.518.001 6.913-5.603 12.514-12.514 12.514z" fill="#ffffff" opacity="1" data-original="#000000"></path></g></svg>
        </div> -->
        <div class="">
        <img  [src]="item.imageThumbUrl" onerror="this.src='../../../../assets/images/photo.png'"/>
        </div>
            </div>
    </ng-template>
  </ng-container>
</owl-carousel-o>
</div>
  <!-- placeholder text end-->



  <!-- <div class="card-carousel">
    <img [src]="postData.postThumbUrl ? postData.postThumbUrl : postData.postThumbImage" alt="" onerror="this.src='../../../../assets/images/photo.png'" style="
    height: 100% !important;
    width: 100% !important;
    object-fit: cover;
    object-position: center;">
  </div> -->
  <mat-card-content>
    <div class="more_oprt">
        <button class="ms-auto option-btn" mat-icon-button aria-label="option menu" [matMenuTriggerFor]="menu">
          <mat-icon>more_horiz</mat-icon>
       </button>
      <mat-menu #menu="matMenu">
      <button (click)="onEdit(postData)" mat-menu-item  >
        <mat-icon class="material-icons-outlined">edit</mat-icon>
        <span>Edit</span>
      </button>
      <button (click)="onShare(postData)" mat-menu-item  >
        <mat-icon class="material-icons-outlined">share</mat-icon>
        <span>Share post</span>
      </button>
      <button (click)="onDeactivate()" mat-menu-item  >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span>Delete</span>
      </button>
    </mat-menu>
    </div>
    <h3 class="fw-500" style="font-weight: bold !important; font-size: 16px;  margin-bottom: 3px; display: -webkit-box;
    -webkit-line-clamp: 1; /* Limit to 2 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal; /* Ensures text wraps within the box */" matTooltip="{{ postData.postTitle }}">
      {{
        postData.postTitle.length > 35
          ? (postData.postTitle.substring(0, 35) + "..." | uppercase)
          : (postData.postTitle | uppercase)
      }}
    </h3>

        <p *ngIf="postData.externalLink && postData.externalLink != 'null'" class="exter_link" [matTooltip]="postData.externalLink"> <span > External link: </span> <a style="cursor: pointer;" (click)="openlink(postData)" class="list_link"> {{postData.externalLink}} </a></p>

    <p matTooltip="{{ postData.postDesc }}" style="display: -webkit-box;
    -webkit-line-clamp: 2; /* Limit to 2 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
        margin-bottom: 25px;
    white-space: normal; /* Ensures text wraps within the box */">
      {{
        postData.postDesc.length > 150
          ? postData.postDesc.substring(0, 150) + "..."
          : postData.postDesc
      }}
    </p>

    <div class="created_on_list">
    <p class="datey_sder">Created on: {{postData.creationTime | date}}</p>
    </div>
    <!-- <p *ngIf="postData.status === 1" class="card-text">Active</p>
    <p *ngIf="postData.status === 2" class="card-text">Deactivated</p> -->
  </mat-card-content>
  <!-- <mat-card-footer class="p-2">
    <p class="mb-0">
      <small>
        <mat-icon class="material-icons-outlined" [inline]="true"
          >place</mat-icon
        >
        Target:
        <span
          class="fw-500"
          *ngIf="
            postData.targetCountry === 'null' ||
            postData.targetCountry === '' ||
            postData.targetCountry === null
          "
          style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap"
          >Global</span
        >
        <span
          class="fw-500"
          *ngIf="
            postData.targetCountry !== 'null' &&
            postData.targetCountry !== '' &&
            postData.targetCountry !== null
          "
          style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap"
          >{{ postData.targetCity }}, {{ postData.targetState }},
          {{ postData.targetCountry }}</span
        >
      </small>
    </p>
  </mat-card-footer> -->
</mat-card>
